module.exports = __webpack_public_path__ + "img/banner_ylhyjjfa.1794f7e4.png";